/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { UploadImageResponse, UploadImageVars } from '../openapi-types.gen.js';

export type { UploadImageResponse, UploadImageVars } from '../openapi-types.gen.js';

export const useUploadImage = createMutationHook<UploadImageVars, UploadImageResponse, unknown>({
  specName: 'useUploadImage',
  path: '/v1/images/ipfs-upload',
  method: 'POST',
  resolveUrl: (vars: UploadImageVars) => `/v1/images/ipfs-upload`,
  buildBody: (vars: UploadImageVars) => {
    const fd = new FormData();
    if (vars.file !== undefined) fd.append('file', vars.file);
    return fd;
  },
  parseResponse: (raw: unknown): UploadImageResponse => raw as UploadImageResponse,
  optimistic: [{
    queryKey: ['images', 'detail'],
    apply: (prev: any, vars: UploadImageVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = { ...next, used: String((Number((next as any).used) || 0) + Number(("1" /* literal */))) };
      next = { ...next, remaining: String((Number((next as any).remaining) || 0) + Number(("-1" /* literal */))) };
      return next;
    },
  }],
  
  
});
